import {Route, Routes, Outlet} from 'react-router-dom'
import {PageTitle} from '../../../../_metronic/layout/core'
import { BlogsListWrapper } from './blogs-list/BlogsList'
const BlogsPage = () => {
  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='/*'
          element={
            <>
              <PageTitle>Blog List</PageTitle>
              <BlogsListWrapper />
            </>
          }
        />
      </Route>
    </Routes>
  )
}

export default BlogsPage
